/*document.addEventListener('DOMContentLoaded', function () {
    const openButtons = document.querySelectorAll('.on-play-btn'); // Buttons to open the modal
    const modal = document.getElementById('VideoModal');
    const closeModal = document.querySelector('.left-close');
    const video = document.querySelector('#VideoHolderLeft video');
    const originalSrc = video.querySelector('source').getAttribute('src'); // Store original source

    // Function to open modal
    function openVideoModal(e) {
        e.preventDefault();
        modal.style.display = 'block';
        modal.classList.add('modal--is-active');
        document.body.style.overflow = 'hidden'; // Prevent background scroll

        // Play video automatically when the modal opens
        video.play();
    }

    // Attach event listeners to all buttons that should open the modal
    openButtons.forEach(button => {
        button.addEventListener('click', openVideoModal);
    });

    // Function to close modal
    function closeVideoModal() {
        modal.style.display = 'none';
        modal.classList.remove('modal--is-active');
        document.body.style.overflow = ''; // Re-enable background scroll

        // Pause the video and reset its current time to 0
        video.pause();
        video.currentTime = 0;
    }

    // Close modal when clicking the close button
    if (closeModal) {
        closeModal.addEventListener('click', closeVideoModal);
    }

    // Close modal when clicking outside the modal content
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeVideoModal();
        }
    });
});*/

$(document).ready(function(e){
  $(document).on('click','.on-play-btn',function(e){
    e.preventDefault();
    let modal_id = $(this).data('id');
    let modal = document.getElementById(modal_id);
    if(!modal){
      return false;
    }
    console.log('modal',modal)
    let videoElement = modal.querySelector('.product-video-mp4-sound');
    let videoType = videoElement.tagName;
    let originalSrc;
    modal.style.display = 'block';
    modal.classList.add('modal--is-active');
    if(videoType == 'IFRAME'){
      originalSrc = videoElement.getAttribute('data-src');      
    }else{
      originalSrc = videoElement.querySelector('source').getAttribute('src')// Original video source URL
    }
    if(videoType == 'IFRAME'){
      videoElement.setAttribute('src', originalSrc); // Adding ?autoplay=1 for safety
    }else{
      // Set video source dynamically to force reload
      videoElement.pause();
      videoElement.querySelector('source').setAttribute('src', originalSrc + '?autoplay=1'); // Adding ?autoplay=1 for safety
      videoElement.load(); // Reload video to apply source change
      videoElement.play().catch(error => console.error('Autoplay failed:', error)); // Attempt to play video
    }
  });

  $(document).on('click','.js-modal-close',function(e){
    let modal_id = $(this).parents('.VideoModal').attr('id');
    
    let modal = document.getElementById(modal_id);
    if(!modal){
      return false;
    }
    let videoElement = modal.querySelector('.product-video-mp4-sound');
    let videoType = videoElement.tagName;
    let originalSrc;
    
    modal.style.display = 'none';
    modal.classList.remove('modal--is-active');
    if(videoType == 'IFRAME'){
      videoElement.setAttribute('src','');
    }else{
      videoElement.pause();
      videoElement.currentTime = 0; // Reset video to the beginning
    }
  });
  // Prevent modal from closing when clicking inside the video container
  $(document).mouseup(function(e){
    var container = $(".modal__inner");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $('.js-modal-close').click();
    }
  });  
})